// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"c7b51000","703":"5ac90276"}[chunkId] + ".chunk.js";
};